import React, { Fragment, memo, useCallback } from 'react';

import { MANUAL_FEATURE_FLAGS } from 'js/featureFlags/featureFlags';
import { useLangFile } from 'js/context/LanguageContext';
import { connect } from 'react-redux';

import { setShowReplaceDialog, setShowSuspendDialog } from 'js/reducers/ReplaceStationReducer';

import { DeleteForeverRounded, SyncRounded } from '@mui/icons-material';

import { Box, ListItemIcon, MenuItem } from '@mui/material';
import useFirebaseAnalytics, { FIREBASE_EVENTS } from '../../hooks/useFirebaseAnalytics';

const mapStateToProps = (store) => {
  return {};
};

const ReplaceStationMenuItemContainer = ({ dispatch }) => {
  const analytics = useFirebaseAnalytics();
  const LangFile = useLangFile();

  if (!MANUAL_FEATURE_FLAGS.ENABLE_REPLACE_STATION) {
    return null;
  }

  // Opening Dialogs
  const handleReplaceStationClicked = useCallback(() => {
    analytics.logEvent(FIREBASE_EVENTS.WEATHER_STATION_SETTINGS_REPLACE);
    dispatch(setShowReplaceDialog(true));
  }, []);

  const handleSuspendStationClicked = useCallback(() => {
    analytics.logEvent(FIREBASE_EVENTS.WEATHER_STATION_SETTINGS_SUSPEND);
    dispatch(setShowSuspendDialog(true));
  }, []);

  let suspendButton = MANUAL_FEATURE_FLAGS.ENABLE_SUSPEND_STATION && (
    <MenuItem onClick={handleSuspendStationClicked}>
      <ListItemIcon>
        <DeleteForeverRounded color={'secondary'} />
      </ListItemIcon>
      <Box
        sx={{
          color: 'secondary.main',
        }}
      >
        {LangFile.ReplaceStationMenuItemContainer.suspendStation}
      </Box>
    </MenuItem>
  );

  return (
    <Fragment>
      <MenuItem onClick={handleReplaceStationClicked}>
        <ListItemIcon>
          <SyncRounded />
        </ListItemIcon>
        {LangFile.ReplaceStationMenuItemContainer.replaceStation}
      </MenuItem>
      {suspendButton}
    </Fragment>
  );
};

export default memo(connect(mapStateToProps)(ReplaceStationMenuItemContainer));
